var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useEffect, useMemo, useState, } from 'react';
export const AuthContext = createContext({});
export const AuthContextProvider = ({ children, authService }) => {
    const [isAuthenticated, setIsAuthenticated] = useState();
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            setIsAuthenticated(yield authService.isAuthenticated());
        }))();
    }, [authService]);
    useEffect(() => {
        authService.subscribe('login', () => __awaiter(void 0, void 0, void 0, function* () { return setIsAuthenticated(true); }));
        authService.subscribe('logout', () => __awaiter(void 0, void 0, void 0, function* () { return setIsAuthenticated(false); }));
    }, []);
    const contextValue = useMemo(() => ({
        authService,
        isAuthenticated: !!isAuthenticated,
        isAuthenticating: isAuthenticated === undefined,
    }), [authService, isAuthenticated]);
    return React.createElement(AuthContext.Provider, { value: contextValue }, children);
};
export const useAuthContext = () => {
    return useContext(AuthContext);
};
